import type { DocumentFileType, FileType } from 'app/src/model'
import type { refundApi } from 'app/src/services/welfareportal'

type RequestedFileAttributesType = {
  documentExtractionType: string
  documentScope: string
  min: number
  max: number
}
export enum FormItemEnum {
  STRING = 0,
  NUMBER = 1,
  DATE = 2,
}
export type FormPropsType = {
  refund: refundApi.Refund
  file: FileType | undefined
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  formData: any
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  formErrors: any
  setFormData: (fieldId: string, fieldValue: unknown, type: FormItemEnum) => void
  setBulkFormData: (fieldIds: string[], fieldValues: unknown[], types: FormItemEnum[]) => void
  resetForm: () => void
}
export type FormComponentInfoType = {
  initializeForm: (file: DocumentFileType, credit: number) => unknown
  fileStepName: string
  documentType: string
  yupSchema: unknown
  syncDocumentWithForm?: (form: unknown, file: DocumentFileType) => Promise<DocumentFileType>
}
export type FileStepType = {
  files: DocumentFileType[]
  stepName: string
}
export type SelectedVouchersType = {
  ids: string[]
  total: number
}
export type StatusCheckerInfoBundleType = {
  filesToCheck: FileStepType[]
  privacyStatementAccept: boolean
  additionalRadioKeys?: string[]
  selectedVoucherInfo?: SelectedVouchersType
  formData: unknown[]
  wizardSteps: WizardStepConfigType[]
}

export type WizardStepConfigType = {
  documentAttributes?: RequestedFileAttributesType
  title?: string
  description?: string
  descriptionPrefix?: JSX.Element
  descriptionSuffix?: JSX.Element
  descriptionModal?: string
  stepName: string
  multiVoucherStep?: boolean
  statusChecker?: (step: WizardStepConfigType, checkerBundleInfo: StatusCheckerInfoBundleType) => boolean
  canAbortRequest?: boolean
  formComponentInfo?: FormComponentInfoType
  confirmationStep?: boolean
}

export interface VoucherItem {
  index: number
  quantity: number
  amount: number
}

export interface VoucherCombination {
  vouchers: VoucherItem[]
  totalAmount: number
  difference: number
}

export interface Voucher {
  amount: number
  quantity: number
}
